import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { VincularEmailTriagemController } from "../../../../Controllers/Geral/Triagem/TriagemControllers";
import { IEmail } from "../../../../Interfaces/Geral/Triagem";
import SelecionarAtendimento from "./SelecionarAtendimento";

interface IVincularEmailProps {
    email: IEmail;
    ID_MODULO: number;
    setShow: (show: boolean) => void;
    update: () => void;
}
interface IVincularEmailFormData {
    DescricaoVinculoEmail: string;
}

export default function VincularEmail(props: IVincularEmailProps) {
    const [idCaso, setIdCaso] = useState(0);
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, formState } =
        useForm<IVincularEmailFormData>();

    function handleVincularEmailSubmit(formData: IVincularEmailFormData) {
        setLoading(true);
        VincularEmailTriagemController({
            ...props.email,
            DescricaoVinculoEmail: formData.DescricaoVinculoEmail,
            ID_CASO: idCaso,
            CategoriaAtendimento: 0,
            SubCategoriaAtendimento: 0,
            EnviarEmail: true,
        })
            .then(() => props.update())
            .then(() => props.setShow(false))
            .finally(() => setLoading(false));
    }

    return (
        <div>
            <h6>Selecionar Caso: </h6>

            <SelecionarAtendimento
                ID_MODULO={props.ID_MODULO}
                onIdCasoChange={setIdCaso}
            />

            <form onSubmit={handleSubmit(handleVincularEmailSubmit)}>
                <label>Descrição:</label>
                <textarea
                    name="DescricaoVinculoEmail"
                    style={{ resize: "vertical" }}
                    className={`form-control ${
                        formState.errors.DescricaoVinculoEmail
                            ? "is-invalid"
                            : ""
                    }`}
                    ref={register({
                        required: "Insira a Descrição para criar um histórico",
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.DescricaoVinculoEmail?.message}
                </div>

                <button
                    className="w-100 mt-5 btn btn-outline-success"
                    disabled={!idCaso || loading}
                >
                    {loading ? (
                        <Spinner size="sm" />
                    ) : (
                        <FontAwesomeIcon icon={faLink} />
                    )}
                    Vincular
                </button>
            </form>
        </div>
    );
}
